
            import { startup } from '/plugins/app/src/app.js';
            window.AppMain = { startup };
            startup(window.appData);
        